// Module
var code = "<div class=\"u-size10of12 ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexEnd u-flexSpaced\" ng-bind=\"row.entity.amountWithCurrency\">\n    </div>\n</div>";
// Exports
module.exports = code;